import Lottie from "react-lottie";
import { BulletIcon, CardList, StepNextButton } from "../../components";
import { SuccessPartyLottie } from "../../assets/lottie";
import { SuccessTickIcon } from "../../assets/icons";
import { CardVariantType } from "../../components/CardList/CardList";
import { useInvoiceFinanceSettings } from "../../hooks";
import { useLoanApplication, useSDKContext } from "../../contexts";
import {
  LoanProductType,
  ShareholderKYCApplicationStatus,
} from "../../hooks/api/types";
import { usePostHog } from "posthog-js/react";
import { useStepper } from "./Stepper";
import { datadogRum } from "@datadog/browser-rum";
import { useDpConfig } from "../../contexts/dpConfig";
import { LoanProduct } from "../../contexts/dpConfig/types";

const SuccessScreen = () => {
  const { state } = useLoanApplication();
  const {
    state: { products },
  } = useDpConfig();
  const { switchDisplayMode } = useSDKContext();
  const { repayableByDPFlag } = useInvoiceFinanceSettings();
  const posthog = usePostHog();
  const { reset } = useStepper();
  const {
    actions: { reset: applicationReset },
  } = useLoanApplication();

  const isLoC =
    state.loanType === LoanProductType.LOC_INVOICE_DISCOUNTING ||
    state.loanType === LoanProductType.LOC_PAYABLE_FINANCING;
  const productConfig = products?.find(
    (product: LoanProduct) => product.type === state.loanType
  );
  let cardIndex = 0;
  const isKYCPending = state.individualShareholders?.some(
    (s) =>
      !s.kycApplication?.length ||
      s.latestKycApplication?.status === ShareholderKYCApplicationStatus.PENDING
  );

  return (
    <div className="cx-flex cx-flex-col cx-items-center cx-w-full cx-px-4 sm:cx-px-6">
      <div className="cx-w-20 cx-h-20 cx-mb-4 cx-relative cx-text-text-brand">
        <div className="cx-absolute cx--top-16 cx--left-20 cx-w-60 cx--z-10">
          <Lottie
            height="100%"
            width="100%"
            options={{
              animationData: SuccessPartyLottie,
              autoplay: true,
            }}
          />
        </div>
        <SuccessTickIcon />
      </div>
      <div className="cx-text-text-primary cx-font-bold cx-text-3xl cx-text-center cx-mb-2 cx-px-2">
        Congratulations!
      </div>
      <div className="cx-text-text-secondary cx-text-center cx-mb-10 cx-w-full cx-max-w-[400px] cx-px-2">
        <p>{`Your ${
          productConfig?.config?.customProductAlias ||
          productConfig?.displayName ||
          "Loan"
        } application is submitted.`}</p>
        <p>What are the next steps?</p>
      </div>
      <div className="cx-w-full cx-max-w-[400px]">
        <div className="cx-flex cx-flex-col cx-w-full">
          <div className="cx-mb-6">
            <CardList
              title="Application review"
              description={`We will review your loan application and you will receive an email update ${
                (state.loanType === LoanProductType.PAYABLE_FINANCING ||
                  state.loanType === LoanProductType.INVOICE_DISCOUNTING) &&
                repayableByDPFlag
                  ? "shortly."
                  : "within 10 minutes."
              }`}
              variant={CardVariantType.SIMPLE}
              icon={<BulletIcon text={`${++cardIndex}`} />}
            />
          </div>
          {isKYCPending && (
            <div className="cx-mb-6">
              <CardList
                title="Shareholders identity verification"
                description="All applicable shareholders will receive an email to verify their identity documents."
                variant={CardVariantType.SIMPLE}
                icon={<BulletIcon text={`${++cardIndex}`} />}
              />
            </div>
          )}
          <div className="cx-mb-6">
            <CardList
              title="Facility agreement"
              description="CredibleX team will send you an offer and next steps."
              variant={CardVariantType.SIMPLE}
              icon={<BulletIcon text={`${++cardIndex}`} />}
            />
          </div>
          <div className="cx-text-text-secondary cx-text-sm cx-mb-10 cx-text-center cx-px-2">
            {isLoC
              ? `Your facility will be activated when each step is successfully completed.`
              : `Your facility will be disbursed when each step is successfully completed.`}
          </div>
          <StepNextButton
            label="Go to dashboard"
            onClick={() => {
              posthog.reset(true);
              datadogRum.clearUser();
              reset();
              applicationReset();
              switchDisplayMode("dashboard");
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default SuccessScreen;
